import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import { Button } from '../Button/Button';

import './SearchBar.scss';

const SearchBar = ({
  onSearchSubmit,
  placeholder,
  buttonLabel,
  defVal = false,
  isOpen,
  ariaLabel,
  roleProp,
  uniqueID
}) => {
  const [input_value, setInputValue] = useState('');

  useEffect(() => {
    if (defVal) setInputValue('');
    return () => {
      setInputValue('');
    };
  }, [defVal]);

  useEffect(() => {
    if (document.querySelector('.search_bar input')) {
      document.querySelector('.search_bar input').focus();
    }
  }, [isOpen]);

  const onChangeHandler = (e) => {
    setInputValue(e.currentTarget.value);
  };

  return (
    <form action="/" className="search_bar" onSubmit={(e) => onSearchSubmit(e, input_value)} {...roleProp && { 'role': roleProp }}>
      <label htmlFor={uniqueID} className="sr_only">{placeholder}</label>
      <input id={uniqueID} type="text" className="input_field_tag" value={input_value} aria-label={ariaLabel} placeholder={placeholder} title={buttonLabel} onChange={onChangeHandler} />
      <Button
        type="submit"
        label={buttonLabel}
      />
    </form>
  );
};

SearchBar.defaultProps = {
  buttonLabel: 'Search',
  placeholder: 'Type your text here',
};

SearchBar.propTypes = {
  onSearchSubmit: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  defVal: PropTypes.bool

};

export default SearchBar;
